import sortOrganizationsOnDelete from '../utils/sortOrganizationsOnDelete';
import tag from '../utils/preTag';
import scrollToSlateNode from '../utils/scrollToSlateNode';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';

export default (params) => {
  const { e, node, editor } = params;

  e.preventDefault();

  const {
    value: { document },
  } = editor;

  /**
   * Organization data
   */

  const organization = node;
  const {
    key: organizationKey,
    data: currentOrganizationData,
    nodes: currentOrganizationNodes,
  } = organization;
  const currentOrganizationOrdinal = currentOrganizationData.get('Ordinal');

  const preTag = tag[node.type];
  const organizationNames = document.getBlocksByTypeAsArray(
    `${preTag}_organization_name`,
  );

  /**
   * A document like work experience would have n * (org + empty_para)
   *
   * If there is only one organization in the entire document, we should not allow the delete
   */
  const { nodes: documentNodes } = document;
  const orgBlocks = documentNodes.toArray();
  const { length } = orgBlocks;
  if (length === 1) return;

  /**
   * Counting total number of roles = (organization details + n*(role details + empty paragraph)) / 2
   *
   * Note: Change the formula as per the structure if necessary
   */
  const totalRoles = Math.floor(currentOrganizationNodes.size - 1);
  const { key: documentKey, data: documentData } = document;
  const documentDataJSON = documentData.toJSON();
  const { rolesCount, selectAll } = documentDataJSON;
  const currentOrganizationSelectAll = currentOrganizationData.get('selectAll');
  const isOrgSelectedAll = totalRoles === currentOrganizationSelectAll;

  const { key: nextOrganizationLogoKey } = document.getNextBlock(
    organizationKey,
  ) || { key: null };

  const indexOfCurrentOrganization = document.nodes
    .toArray()
    .indexOf(organization);

  editor.removeNodeByKey(organizationKey);

  /**
   * Update document data only if there is atlease one role which gets exported
   */
  if (currentOrganizationSelectAll > 0) {
    editor.setNodeByKey(documentKey, {
      data: {
        ...documentDataJSON,
        selectAll: isOrgSelectedAll ? selectAll - 1 : selectAll,
        rolesCount: rolesCount - currentOrganizationSelectAll,
      },
    });
  }

  /**
   * If the organization is last one in the document
   */
  const {
    value: { document: updatedDocument },
  } = editor;

  if (!nextOrganizationLogoKey) {
    /**
     * Fetching previous blocks before delete
     */
    const previousBlock = document.getPreviousBlock(node.key);

    const organizationBlock = updatedDocument.getParent(previousBlock.key);

    const { nodes } = organizationBlock;
    const { nodes: organizationDetailsNodes } = nodes.toArray()[0];
    const [skillOrganization] = organizationDetailsNodes.toArray();
    if (preTag === 'skill') {
      editor.moveToEndOfNode(skillOrganization);
      if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
      scrollToSlateNode(organizationBlock);
    } else {
      const previousOrganization =
        editor.value.document.nodes.toArray()[indexOfCurrentOrganization - 1];
      const previousOrganizationDetails =
        previousOrganization && previousOrganization.nodes.toArray()[0];

      const previousOrganizationDetailsFirstFocusableNode =
        previousOrganizationDetails &&
        previousOrganizationDetails.nodes.toArray()[1];
      editor.moveToEndOfNode(previousOrganizationDetailsFirstFocusableNode);
      if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
      scrollToSlateNode(previousOrganization);
    }
    return;
  }

  const nextBlock = document.getNextBlock(organizationKey);

  const organizationDetailsBlock = updatedDocument.getParent(nextBlock.key);

  const organizationBlock = updatedDocument.getParent(
    organizationDetailsBlock.key,
  );

  const { nodes } = organizationBlock;
  const { nodes: organizationDetailsNodes } = nodes.toArray()[0];
  const [skillOrganization] = organizationDetailsNodes.toArray();

  if (preTag === 'skill') {
    editor.moveToEndOfNode(skillOrganization);
    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
    scrollToSlateNode(organizationBlock);
  } else {
    const previousOrganization =
      editor.value.document.nodes.toArray()[indexOfCurrentOrganization];
    const previousOrganizationDetails =
      previousOrganization && previousOrganization.nodes.toArray()[0];

    const previousOrganizationDetailsFirstFocusableNode =
      previousOrganizationDetails &&
      previousOrganizationDetails.nodes.toArray()[1];
    editor.moveToEndOfNode(previousOrganizationDetailsFirstFocusableNode);
    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
    scrollToSlateNode(previousOrganization);
  }

  let { key: nextOrganizationNameKey } = document.getNextBlock(
    nextOrganizationLogoKey,
  );
  if (preTag === 'skill') {
    nextOrganizationNameKey = nextOrganizationLogoKey;
  }
  sortOrganizationsOnDelete({
    currentOrganizationOrdinal,
    organizationNames,
    nextOrganizationNameKey,
    editor,
  });
};
